// Copyright (c) 2024 by Audere

import { useGetSummaryQuery } from "../features/api/labelApiSlice";
import { selectCurrentUserPersistentGroupRole } from "../features/slices/authSlice";
import { useSelector } from "react-redux";

export const useSummary = (conversation_uid: string) => {
  const userGroupRole = useSelector(selectCurrentUserPersistentGroupRole);
  const { data, isFetching, error } = useGetSummaryQuery(
    {
      group: userGroupRole.group,
      conversation_uid,
    },
    {
      pollingInterval: 0, // No polling
      skipPollingIfUnfocused: true,
      refetchOnFocus: false,
      refetchOnReconnect: true,
      skip: !conversation_uid,
    }
  );

  const summary = data?.summary ?? "";

  return { summary, isFetching, error };
};
